import React from 'react';
import { Link } from 'react-router';

type Props = {
  children: React.ReactNode;
  to: string;
};

export const TableRowLink: React.FC<Props> = ({ children, to }) => {
  return (
    <Link
      onClick={e => e.stopPropagation()}
      style={{ color: 'inherit', textDecoration: 'none' }}
      to={to}
      viewTransition
    >
      {children}
    </Link>
  );
};
